import React from 'react';

import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import FeaturesImage from './images/features.png';

import './empty-state.css';

const i18n = I18N.surveyCreate.presetDescription;
const b = b_.with('survey-picker');

export default function EmptyState() {
    return (
        <div className={b('empty-state')}>
            <img className={b('empty-state-image')} src={FeaturesImage} />
            <h2 className={b('empty-state-header')}>{i18n.emptyState.header}</h2>
            <span className={b('empty-state-caption')}>{i18n.emptyState.caption}</span>
        </div>
    );
}
